import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react';
import { Box } from '@mui/material';

import { angularizeWithProviders } from '../../../shared/providers';
import { Header } from './components/Header/Header';
import { DeclineRequestModal } from './components/DeclineRequestModal/DeclineRequestModal';
import { stepperStore } from '../../stores/stepperStore';
import { childInformationStore } from '../../stores/childInformationStore';
import { CreditCardInfo } from './containers/CreditCardInfo/CreditCardInfo';
import classes from './NgzProceedRegistration.module.scss';
import { Terms } from './containers/Terms/Terms';
import { PersonalInfo } from './containers/PersonalInfo/PersonalInfo';
import { Subscription } from './containers/Subscription/Subscription';
import { Finish } from './containers/Finish/Finish';

const defaultSteps = [
  { step: <Terms />, label: 'Term' },
  { step: <PersonalInfo />, label: 'Personal Information' },
  { step: <Subscription />, label: 'Subscription' },
  { step: <Finish />, label: 'Finish' },
];

const NgzProceedRegistration = observer(() => {
  const [steps, setSteps] = useState(defaultSteps);
  const { activeStep, setStepsCount, stepsCount } = stepperStore;
  const { loadChildInfo, isEntityWithStripe } = childInformationStore;

  useEffect(() => {
    loadChildInfo();
  }, []);

  useEffect(() => {
    processSteps();
  }, [isEntityWithStripe]);

  const processSteps = () => {
    if (isEntityWithStripe) {
      addCreditCardStep();
    }
  };

  const addCreditCardStep = () => {
    const creditCardInfoStepIndex = stepsCount - 1;
    const creditCardInfoStep = { step: <CreditCardInfo />, label: 'Credit card info' };
    const newSteps = [...steps];
    newSteps.splice(creditCardInfoStepIndex, 0, creditCardInfoStep);
    setSteps(newSteps);
    setStepsCount(newSteps.length);
  };

  const notLastStep = activeStep !== stepsCount;

  return (
    <Box className={classes.container}>
      {notLastStep && <Header />}
      {steps[activeStep - 1].step}
      <DeclineRequestModal />
    </Box>
  );
});

angularizeWithProviders(NgzProceedRegistration, 'ngzProceedRegistration', {});

export default NgzProceedRegistration;
